module.exports = __webpack_public_path__ + "img/tokyodate_nsfw.b9779e38.svg";